import React, { useEffect, useState } from 'react';

import lang from '../../lang/lang';

import Select, {components} from 'react-select';

import { BackStyled, InfoStyled, LanguageSelectStyled, MainStyled, SettingsMainStyled, SettingsWrapperStyled, DefaultLanguageStyled, ThemeSelectStyled } from './Settings.styled';

const Settings = () => {
    const optionsLanguage = [
        {value: 'uk', label: 'Українська'},
        {value: 'en', label: 'English'},
    ];
    const optionsTheme = [
        {value: 'dark', label: 'Dark'},
        {value: 'light', label: 'Light'}
    ];
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            boxShadow: '0',
            boxShadow: state.isFocused ? '0 0 0 1px #FF5733' : 'hsl(0, 0%, 80%)',
            borderColor: state.isFocused ? '#FF5733' : 'hsl(0, 0%, 80%)',
            backgroundColor: (localStorage.getItem('theme') === 'dark') ? 'black' : 'white',
            '&:hover': {
                borderColor: state.isFocused ? '#FF5733' : 'hsl(0, 0%, 80%)'
            },
            "@media screen and (max-width: 576px)": {
                minHeight: '60px'
            }
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: (localStorage.getItem('theme') === 'dark') ? 'black' : 'white',
            color: state.isSelected ? 'red' : (localStorage.getItem('theme') === 'dark') ? 'hsl(0deg 0% 83%)' : 'hsl(0, 0%, 20%)',
            '&:hover': {
                color: '#FF5733'
            },
            "@media screen and (max-width: 576px)": {
                padding: '20px 12px'
            }
        }),
        placeholder: (base, state) => ({
            ...base,
            color: (localStorage.getItem('theme') === 'dark') ? 'hsl(0deg 0% 83%)' : 'hsl(0, 0%, 20%)'
        }),
        menu: (base, state) => ({
            ...base,
            backgroundColor: (localStorage.getItem('theme') === 'dark') ? 'black' : 'white'
        })
    }
    const [language, setLanguage] = useState('');
    const [langState, setLangState] = useState(localStorage.getItem('language') || 'en')


    const handleBackClick = () => {
        localStorage.setItem('settingsIsOpen', false);
        window.location.reload();
    }

    const handleSelectLanguageChange = (e) => {
        if(e) {
            localStorage.setItem('language', e.value);
            window.location.reload();
        }
    }

    const handleSelectThemeChange = (e) => {
        if(e) {
            localStorage.setItem('theme', e.value);
            window.location.reload();
        }
    }

    useEffect(() => {
        if(localStorage.getItem('language')) {
            setLanguage(localStorage.getItem('language'));
        }
    }, []);

    const NoOptionsMessage = props => {
        return (
          <components.NoOptionsMessage {...props}>
            <span>{langState === 'uk' ? lang.uk.noOptions : lang.en.noOptions}</span> 
          </components.NoOptionsMessage>
        );
      };

    return <>
        <SettingsWrapperStyled>
            <BackStyled>
                <button onClick={handleBackClick}>
                    <span className='icon-arrow-back'></span>
                    <span>{langState === 'uk' ? lang.uk.back : lang.en.back}</span>
                </button>
            </BackStyled>
            <SettingsMainStyled>
                <InfoStyled>
                    <span className='icon-info'></span>
                    <span>{langState === 'uk' ? lang.uk.settings.info : lang.en.settings.info}</span>
                </InfoStyled>
                    <MainStyled>
                        <LanguageSelectStyled>
                            <span>{langState === 'uk' ? lang.uk.settings.selectLanguage : lang.en.settings.selectLanguage}</span>
                            <div>
                                <Select 
                                    options={optionsLanguage} 
                                    className='custom-select'
                                    styles={selectStyles}
                                    isClearable={false}
                                    onChange={(e) => handleSelectLanguageChange(e)}
                                    placeholder={langState === 'uk' ? lang.uk.settings.selectLangPlaceholder : lang.en.settings.selectLangPlaceholder}
                                    components={{NoOptionsMessage}}
                                />
                            </div>
                        </LanguageSelectStyled>
                        <ThemeSelectStyled>
                        <span>{langState === 'uk' ? lang.uk.settings.selectTheme : lang.en.settings.selectTheme}</span>
                            <div>
                                <Select 
                                    options={optionsTheme} 
                                    className='custom-select'
                                    styles={selectStyles}
                                    isClearable={false}
                                    onChange={(e) => handleSelectThemeChange(e)}
                                    placeholder={langState === 'uk' ? lang.uk.settings.selectThemePlaceholder : lang.en.settings.selectThemePlaceholder}
                                    components={{NoOptionsMessage}}
                                />
                            </div>
                        </ThemeSelectStyled>
                    </MainStyled>
            </SettingsMainStyled>
        </SettingsWrapperStyled>
    </>;
}

export default Settings;